import utils from "@/components/declarations/validators/utils";

export default {
  isValid(self, isDraft) {
    const errors = {
      atLeastOne: false,
      boilersLength: false,
      wrongBoilersCount: false,
      boilers: self.boilers.map((el) => {
        return {
          boilerClass: false,
          count: false
        }
      })
    };
    self.setErrors(errors);

    if (!utils.solidFuelBoilersCount(self)) {
      return errors;
    }

    let text = "";

    if (!isDraft && !self.boilers.length) {
      errors.boilersLength = true;
      text += "Brak możliwości przejścia dalej ze względu na brak wyboru klasy kotła/kotłów. <br/>";
      errors.atLeastOne = true;
    }

    let solidFuelBoilersCount = 0;
    let boilerClassesTotalCount = 0;

    self.$parent.$refs[`screen2`].heatSources.forEach((el) => {
      if (el.type.is_solid_fuel) {
        solidFuelBoilersCount += parseInt(el.amount);
      }
    });

    self.boilers.forEach((boiler, index) => {
      boilerClassesTotalCount += parseInt(boiler.count);

      if (!boiler.boilerClass.id) {
        errors.boilers[index].boilerClass = true;
        errors.atLeastOne = true;
        text += "Prosimy o wybranie klasy kotła na paliwo stałe <br/>";
      }

      if (isNaN(parseInt(boiler.count)) || self.count <= 0 || boiler.count <= 0) {
        errors.boilers[index].count = true;
        errors.atLeastOne = true;
        text += "Prosimy o podanie liczby kotłów w wybranej klasie<br/>";
      }

    });

    if (!isDraft && boilerClassesTotalCount !== solidFuelBoilersCount) {
      errors.wrongBoilersCount = true;
      errors.atLeastOne = true;
      text += "Podana liczba klas kotłów nie zgadza się z liczbą kotłów na paliwo stałe. <br/>";
    }

    if (errors.atLeastOne) {
      utils.showMessage(self, text);
    }

    return errors;
  }
}
